import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user/user.service';
import { User } from 'src/app/model/user.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-siteuser',
  templateUrl: './siteuser.component.html',
  styleUrls: ['./siteuser.component.css']
})
export class SiteuserComponent implements OnInit {
  data: any;
  UserDataAny: any;
  currentUserData: any;
  // columnDefs = [
  //   { field: 'fullName' },
  //   { field: 'email' },
  //   { field: 'phoneNumber'},
  //   { field: 'type' },
  //   { field: 'isActive' },
  //   { field: 'createdBy' },
  //   { field: 'createdOn' },
  //   { field: 'updatedBy' },
  //   { field: 'updatedOn' },
  //   { field: 'registerCode' }
  // ];
//   columnDefs = [
//     { headerName:'Make', field: 'make' },
//     { headerName:'Model', field: 'model' },
//     { headerName:'Price',field: 'price'}
// ];
// rowData = [
//   { make: 'Toyota', model: 'Celica', price: 35000 },
//   { make: 'Ford', model: 'Mondeo', price: 32000 },
//   { make: 'Porsche', model: 'Boxter', price: 72000 }
// ];

  constructor(private router: Router, private userService: UserService) { }

  ngOnInit() {
    debugger;
    this.getUserData();

    this.userService.currentUser.subscribe(
      (userdata) => {
        this.currentUserData = userdata;
        console.log("current");
        console.log(this.currentUserData);
      }
    );

    // this.userService.getUsersData().subscribe(
    //   (data) => {
    //     this.UserDataAny = data;
    //     this.data = this.UserDataAny;
    //     console.log("user data"+this.data);
    //   }
    // )
  }
  getUserData() {
    this.userService.getUsersData().subscribe(
      (data) => {
        this.UserDataAny = data;
        this.data = this.UserDataAny;
        console.log("user data" + this.data);
      }
    )
  }
  editSiteUser = function (id) {
    //alert(id);
    this.router.navigate(['/siteuseredit/' + id + '']);
  }
  removeSiteUser(id) {
    this.userService.removeSiteUser(id).subscribe(
      (data: any) => {
        if (data == true) {
          this.getUserData();
        }
        else {

        }
      }
    )
  }
  message = function (id) {
    //alert(id)
    // this.router.navigate(['/messagelist/' + id + '']);
    this.router.navigate(['/messagelist']);
  }

  searchVendor(keyword) {
    this.userService.searchVendor(keyword).subscribe(
      (data) => {
        this.data = data;
        console.log(data);
      }
    );
  }

}
